
// Default values for booking settings

export const defaultAvailability = {
  monday: { enabled: true, startTime: '09:00', endTime: '17:00' },
  tuesday: { enabled: true, startTime: '09:00', endTime: '17:00' },
  wednesday: { enabled: true, startTime: '09:00', endTime: '17:00' },
  thursday: { enabled: true, startTime: '09:00', endTime: '17:00' },
  friday: { enabled: true, startTime: '09:00', endTime: '17:00' },
  saturday: { enabled: false, startTime: '09:00', endTime: '17:00' },
  sunday: { enabled: false, startTime: '09:00', endTime: '17:00' },
};

export const defaultMeetingTypes = {
  zoom: true,
  googleMeet: false,
  phone: false,
  inPerson: false,
};

export const defaultPayment = {
  required: false,
  amount: 0,
};

export const defaultProviderInfo = {
  category: '',
  description: '',
  bio: '',
  photoUrl: '',
};

export const defaultServiceDetails = {
  name: '',
  description: '',
  price: 0,
  cancellationPolicy: '',
};

export const createDefaultBookingLink = () => ({
  id: crypto.randomUUID(),
  name: '',
  duration: 30 as 15 | 30 | 60, // Explicitly cast to the union type
  availability: defaultAvailability,
  meetingTypes: defaultMeetingTypes,
  payment: defaultPayment,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  locations: [],
  recurring: {
    enabled: false,
    frequency: 'weekly' as 'daily' | 'weekly' | 'monthly',
  },
  providerInfo: defaultProviderInfo,
  serviceDetails: defaultServiceDetails,
});
